module.exports = __webpack_public_path__ + "static/media/download_icon.541553f4.svg";